<div class="container contentHeight lstproducts">
    <!--<mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>-->
    <div class="mat-action-list mx-auto">
      <button class="btn btn-secondary mb-1" style="width: auto;" (click)="openModalAddProd()">Ajouter un produit</button>
    </div>
    <div class="product">
      <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="productSource">
        <ng-container matColumnDef="label">
          <mat-header-cell *matHeaderCellDef>Produit</mat-header-cell>
          <mat-cell *matCellDef="let product">
            {{product.labelP}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="price">
          <mat-header-cell *matHeaderCellDef>Prix</mat-header-cell>
          <mat-cell *matCellDef="let product">
            {{product.amountP | number : '1.2-2'}} €
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let product">
            {{product.typeP}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="qty">
          <mat-header-cell *matHeaderCellDef>Quantité max. commandable</mat-header-cell>
          <mat-cell *matCellDef="let product">
            {{product.qteStock}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="available">
          <mat-header-cell *matHeaderCellDef>Disponibilité</mat-header-cell>
          <mat-cell *matCellDef="let product">
            <mat-slide-toggle [checked]="product.available" (change)="changeDispo(product.productID)" hideIcon></mat-slide-toggle>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="renting">
          <mat-header-cell *matHeaderCellDef>Location</mat-header-cell>
          <mat-cell *matCellDef="let product">
            <mat-slide-toggle  [checked]="product.rentable == 1" (change)="changeRentable(product.productID)" hideIcon></mat-slide-toggle>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rentingFraisLiv">
          <mat-header-cell *matHeaderCellDef>Frais de livraison location</mat-header-cell>
          <mat-cell *matCellDef="let product">
            <mat-slide-toggle  [checked]="product.fraisLivRentable == 1" (change)="changeRentableFraisLiv(product.productID)" hideIcon></mat-slide-toggle>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="picture">
          <mat-header-cell *matHeaderCellDef>Image</mat-header-cell>
          <mat-cell *matCellDef="let product">
            <img alt="" class="thumbnail" src="data:image/png;base64,{{product.pictureBlob2}}" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>Edition</mat-header-cell>
          <mat-cell *matCellDef="let product">
            <a class="fal fa-edit fa-1x5" style="cursor: pointer;" (click)="openModalEditProd(product.productID)" matTooltip="Edition"></a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
</div>

<div *ngIf="displayModalDeleteProduct || displayModalAddProduct || displayModalEditProduct" id="ModalBackdrop">

</div>

<div *ngIf="displayModalAddProduct || displayModalEditProduct" id="ModalAddProduct" class="modal">
  <div class="modal-content">
    <div *ngIf="displayModalAddProduct">
      <h3 class="leftFlex">Ajout d'un produit</h3>
      <span class="rightFlex pointer close" (click)="closeModalAddProd()">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    </div>
    <div *ngIf="displayModalEditProduct">
      <h3 class="leftFlex">Edition d'un produit</h3>
      <span class="rightFlex pointer close" (click)="closeModalEditProd()">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    </div>
    <div>
      <form [formGroup]="ProductForm" (ngSubmit)="addProduct()">
        <div class="flex-container">
          <div class="flex-subcontainer">
            <div class="flex-title">
              <h5 style="font-weight: bold;">Désignation du produit</h5>
              <div class="part"></div>
            </div>

            <div class="item-group">
              <div class="titleLeft">Français</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelFR" formControlName="labelP" class="element" value="{{prodM.labelP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Allemand</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelDE" formControlName="labelDEP" class="element" value="{{prodM.labelDEP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Anglais</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelEN" formControlName="labelENP" class="element" value="{{prodM.labelENP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Espagnol</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelES" formControlName="labelESP" class="element" value="{{prodM.labelESP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Italien</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelIT" formControlName="labelITP" class="element" value="{{prodM.labelITP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Neerlandais</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelNL" formControlName="labelNLP" class="element" value="{{prodM.labelNLP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Polonais</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelPL" formControlName="labelPLP" class="element" value="{{prodM.labelPLP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Portugais</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelPT" formControlName="labelPTP" class="element" value="{{prodM.labelPTP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Roumain</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelRO" formControlName="labelROP" class="element" value="{{prodM.labelROP}}" required />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Turc</div>
              <div class="contentLeft">
                <mat-label>Désignation</mat-label>
                <input type="text" id="labelTR" formControlName="labelTRP" class="element" value="{{prodM.labelTRP}}" required />
              </div>
            </div>
          </div>
          <div class="flex-subcontainer">
            <div class="flex-title">
              <h5 style="font-weight: bold;">Frais de livraison du produit</h5>
              <div class="part"></div>
            </div>
            <div class="item-group col-12">
              <div>Frais de livraison sur devis :<mat-slide-toggle formControlName="fraisLivManuel" (change)="changeValue()" hideIcon></mat-slide-toggle></div>
            </div>
            <div class="item-group">
              <div class="titleLeft">France</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivP" formControlName="fraisLivP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Allemagne</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivDEP" formControlName="fraisLivDEP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivDEP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Angleterre </div>
              <div class="contentLeft">
                <input type="number" id="fraisLivENP" formControlName="fraisLivENP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivENP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Belgique</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivBEP" formControlName="fraisLivBEP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivBEP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Espagne</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivESP" formControlName="fraisLivESP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivESP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Italie</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivITP" formControlName="fraisLivITP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivITP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Pays-Bas</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivNLP" formControlName="fraisLivNLP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivNLP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Pologne</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivPLP" formControlName="fraisLivPLP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivPLP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Portugal</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivPTP" formControlName="fraisLivPTP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivPTP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Roumanie</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivROP" formControlName="fraisLivROP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivROP | number : '1.2-2'}}" />
              </div>
            </div>
            <div class="item-group">
              <div class="titleLeft">Turquie</div>
              <div class="contentLeft">
                <input type="number" id="fraisLivTRP" formControlName="fraisLivTRP" class="element priceInput" min="0" max="1000000" maxlength="7" value="{{prodM.fraisLivTRP | number : '1.2-2'}}" />
              </div>
            </div>
          </div>
          <div class="flex-subcontainer">
            <div class="flex-title">
              <h5 style="font-weight: bold;">Autres</h5>
              <div class="part"></div>
            </div>

            <div class="item-group">
              <div>Prix (€) : </div>
              <div>
                <input type="number" min="1" formControlName="amount" class="element priceInput" value="{{prodM.amountP | number : '1.2-2'}}" max="1000000" maxlength="7" step="1" pattern="^\d+(?:\.\d{1,2})?$" />
              </div>
            </div>
            <div class="item-group">
              <div>Type de produit : </div>
              <div>
                <mat-select class="element" formControlName="type">
                  <mat-option value="{{item}}" (click)="changeValue('ProduitType')" *ngFor="let item of productTypes">{{item}}</mat-option>
                  <!--<mat-option value="support" (click)="changeValue()">Support</mat-option>
        <mat-option value="reseau" (click)="changeValue()">Réseau</mat-option>
        <mat-option value="cables" (click)="changeValue()">Cables</mat-option>
        <mat-option value="divers" (click)="changeValue()">Divers</mat-option>-->
                </mat-select>
              </div>
            </div>
            <div class="item-group">
              <div>Quantité max. commandable :</div>
              <div>
                <input type="number" min="0" formControlName="qty" value="{{prodM.qteStock}}" max="1000000" pattern="^\d{0,7}$" class="element" />
              </div>
            </div>
            <div class="item-group">
              <div>Disponibilité :</div>
              <div>
                <mat-slide-toggle formControlName="available" hideIcon></mat-slide-toggle>
              </div>
            </div>
            <div class="item-group">
              <div>Balance(s) concernée(s) : </div>
              <div>
                <mat-checkbox *ngFor="let Scale of checkScale" id="{{ Scale.name }}" class="checkbox-margin" [checked]="Scale.check">{{ Scale.name }}</mat-checkbox>
              </div>
              </div>
          </div>
          <div class="flex-subcontainer" style="justify-content: space-around;">
            <div class="flex-title">
              <h5 style="font-weight: bold;">Image</h5>
              <div class="part"></div>
            </div>

            <div class="item-group" style="display: flex;">
              <div>Image : </div>
              <div style="display: flex;">
                <input #file type="file" accept="image/*" class="element" (change)="onFileChanged($event, file)" />
                <img *ngIf="prodM.pictureBlob2!=null" src="data:image/png;base64,{{prodM.pictureBlob2}}" class="thumbnailAdd" alt="" />
              </div>
            </div>
            <div class="item-group" style="display: flex;">
              <div>Image Explicative : </div>
              <div style="display: flex;">
                <input #file type="file" accept="image/*" class="element" (change)="onFileZoomChanged($event, file)" />
                <img *ngIf="prodM.pictureZoomDisplayBlob!=null" src="data:image/png;base64,{{prodM.pictureZoomDisplayBlob}}" class="thumbnailAdd" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="center" *ngIf="displayModalAddProduct">
          <button class="btn btn-secondary btnReglement button" type="button"  name="Annuler ADD" value="Annuler" (click)="closeModalAddProd()">Annuler</button>
          <button class="btn btn-secondary btnReglement button" type="submit"  [disabled]="ProductForm.invalid || !btypeProduit || selectedImg == null ">Enregistrer</button>
        </div>

        <div class="center" *ngIf="displayModalEditProduct">
          <button class="btn btn-secondary btnReglement" type="button" (click)="closeModalEditProd()">Annuler</button>
          <button class="btn btn-secondary btnReglement" type="button" (click)="editProduct()" [disabled]="ProductForm.invalid || !btypeProduit">Enregistrer</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="displayModalDeleteProduct" id="ModalDeleteProduct" class="modal">
  <div class="modal-content">
    <div>
      <h3 class="leftFlex">Edition d'un produit</h3>
      <span class="rightFlex pointer close" (click)="closeModalDeleteProd()">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    </div>
    <div>
      <input hidden value="{{prod.productID}}" />
      <p>Etes-vous sûr de vouloir supprimer ce produit.</p>
    </div>
    <div class="center">
      <button class="btn btn-secondary btnReglement" type="button"  name="Annuler" value="Annuler" (click)="closeModalDeleteProd()">Annuler</button>
      <button class="btn btn-secondary btnReglement" type="button"  name="Supprimer" value="Supprimer" (click)="deleteProduct()">Supprimer</button>
    </div>
  </div>
</div>
